// extracted by mini-css-extract-plugin
export var tabbedImages = "tabbed-images-module--tabbedImages--0Wzx9";